export const trackTestimonialsProperties = (payload, properties) => {
  const testimonialsSection = payload.sections.filter(s => s.name === 'TESTIMONIALS');
  if (testimonialsSection.length > 0) {
    properties.push({
      label: 'Number of Testimonials',
      value: testimonialsSection[0].dataSource.length,
    });
  }
};